import {createActions} from 'client/framework';

export default createActions(null, [
  'RESET_STORE',
  'CHECKBOX_GROUP_SELECTION',
  'CHECKBOX_GROUP_DESELECTION'
]);
